var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12.076,
    viewBox: "0 0 15 12.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3553b2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-54.873-214.478l-.594-.622-5.5,5.765a1.754,1.754,0,0,1-2.533,0l-5.5-5.732-.594.622,4.1,4.291-4.1,4.291.594.622,4.1-4.291.813.852a2.55,2.55,0,0,0,1.845.819,2.55,2.55,0,0,0,1.845-.819l.813-.852,4.1,4.291.594-.622-4.1-4.291,4.127-4.324",
    transform: "translate(69.702 216.157)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-56.215-206.124h-12.37A1.36,1.36,0,0,1-69.9-207.51v-9.3a1.36,1.36,0,0,1,1.315-1.386h12.37a1.36,1.36,0,0,1,1.315,1.386v9.3a1.36,1.36,0,0,1-1.315,1.386Zm-12.4-11.185a.44.44,0,0,0-.438.462v9.3a.44.44,0,0,0,.438.462h12.37a.44.44,0,0,0,.438-.462v-9.3a.44.44,0,0,0-.438-.462Z",
    transform: "translate(69.9 218.2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/IconEnvelope.95c5b7ba.svg";
export { ForwardRef as ReactComponent };